<script setup lang="ts">
</script>
<template>
    <NuxtPwaManifest />
    <div>
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </div>
</template>